__turbopack_context__.v({
  "delegatedRoot": "TotalBalance-module-scss-module__aXKUFa__delegatedRoot" + " " + "TotalBalance-module-scss-module__aXKUFa__root",
  "publicKey": "TotalBalance-module-scss-module__aXKUFa__publicKey",
  "root": "TotalBalance-module-scss-module__aXKUFa__root",
  "totalAmount": "TotalBalance-module-scss-module__aXKUFa__totalAmount",
  "totalTitle": "TotalBalance-module-scss-module__aXKUFa__totalTitle",
});
